import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';

import Loader from 'react-loader-spinner';

var Config = require('../../../config');

class ModalClearCaller extends Component{
	constructor(props){
		super(props);

		this.state = {
            show: false,
            option_clear:"",
            clearing:false
		}
        this.handleChange = this.handleChange.bind(this);
		this.handleShow  = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.clearCaller = this.clearCaller.bind(this);
	}

	componentDidMount(){
		this.props.onRef(this);
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }
    
    handleShow() {
		this.setState({ show: true, option_clear:"", clearing:false});
	}

	handleClose(){
		this.setState({show:false});
    }
    
    clearCaller(){
        if(this.state.option_clear === ""){
            swal("Error", "Debe seleccionar una opción", 'error');
            return;
        }
        fetch(Config.default.apiGateway.URL+'caller_actions_history?option='+this.state.option_clear, {
            method :'DELETE',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
                })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                console.log('error');
            }
        }).then(response =>{
            if(response !== undefined){
                this.props.refresh();
            }
        })
        
    }

	render(){
		const { t } = this.props;

		return (
			<div>
				<Modal dialogClassName="custom-modal" show={this.state.show} onHide={this.handleClose} backdrop="static" keyboard={false}>
					<Modal.Header closeButton>
						<Modal.Title>Limpiar Listado</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
                            {this.state.clearing?
                                <div style={{textAlign:'center'}}>
                                    <Loader type="Oval" color="#64b5f6" height={80} width={80}/> 
                                </div>
                            :
                            <div className="col-xs-12 col-sm-6">
                                <span className="span-min">Seleccione una opción:</span>
                                <select className="form-control" name="option_clear" id="option_clear" value={ this.state.option_clear || ""}
                                    onChange={ this.handleChange}>
                                    <option value="" disabled >Seleccionar...</option>
                                    <option value="continue_sequence" >Continuar Numeración</option>
                                    <option value="restart_sequence" >Reiniciar Numeración</option>
                                </select>
                            </div>}	
						</div>
					</Modal.Body>
					<Modal.Footer>
                        <FlatButton disabled={this.state.clearing} primary={true} label={t('content.generics.buttons.accept')}  onClick={this.clearCaller}/>
			        	<FlatButton disabled={this.state.clearing} primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
			        </Modal.Footer>
				</Modal>

				<WaitingModal {...this.props} onRef={ref=>this.waiting_modal = ref} />
			</div>
		)
	}
}

export default ModalClearCaller;